import React from 'react';
import * as Sentry from '@sentry/react';

export default class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { error: null };
	}

	componentDidCatch(error, errorInfo) {
		this.setState({ error });
		Sentry.withScope((scope) => {
			Object.keys(errorInfo).forEach((key) => {
				scope.setExtra(key, errorInfo[key]);
			});
			Sentry.captureException(error, { extra: errorInfo });
		});
	}

	render() {
		if (this.state.error) {
			// render fallback UI
			return (
				<div className="row error">
					<div className="col text-center">
						<h3>We're sorry — something's gone wrong.</h3>
						<p>Our team has been notified.</p>
					</div>
				</div>
			);
		}
		// when there's not an error, render children untouched
		return this.props.children;
	}
}
